/**
 * Ensures that character in position 0 is a hashtag,
 * if not, adds it, extending the string.
 * 
 * Let's through undefined without any modifications.
 */
export default function ensureHashtag(st: string | undefined) {
  if (st === undefined) return st

  if (!st.startsWith('#')) st = '#' + st
  return st
}
